import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.u3p_1 = new (MarkdownContent())('aboutMd', 'connectSuccessMd', 'contributionStartMd', 'boostMd', 'recentInfoMd', 'installSuccessMd');
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var MarkdownContentClass;
function MarkdownContent() {
  if (MarkdownContentClass === VOID) {
    class $ {
      constructor(aboutMd, connectSuccessMd, contributionStartMd, boostMd, recentInfoMd, installSuccessMd) {
        Companion_getInstance();
        this.v3p_1 = aboutMd;
        this.w3p_1 = connectSuccessMd;
        this.x3p_1 = contributionStartMd;
        this.y3p_1 = boostMd;
        this.z3p_1 = recentInfoMd;
        this.a3q_1 = installSuccessMd;
      }
      toString() {
        return 'MarkdownContent(aboutMd=' + this.v3p_1 + ', connectSuccessMd=' + this.w3p_1 + ', contributionStartMd=' + this.x3p_1 + ', boostMd=' + this.y3p_1 + ', recentInfoMd=' + this.z3p_1 + ', installSuccessMd=' + this.a3q_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.v3p_1);
        result = imul(result, 31) + getStringHashCode(this.w3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.x3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.y3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.z3p_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.a3q_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof MarkdownContent()))
          return false;
        if (!(this.v3p_1 === other.v3p_1))
          return false;
        if (!(this.w3p_1 === other.w3p_1))
          return false;
        if (!(this.x3p_1 === other.x3p_1))
          return false;
        if (!(this.y3p_1 === other.y3p_1))
          return false;
        if (!(this.z3p_1 === other.z3p_1))
          return false;
        if (!(this.a3q_1 === other.a3q_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'MarkdownContent');
    MarkdownContentClass = $;
  }
  return MarkdownContentClass;
}
//region block: exports
export {
  MarkdownContent as MarkdownContent25fmztzs0fh3a,
  Companion_getInstance as Companion_getInstancem9e45a6g7tc7,
};
//endregion

//# sourceMappingURL=MarkdownContent.mjs.map
